export default __webpack_public_path__ + "static/media/16d81f3fc435421b83951ddd8bf40401.79bc1c50.png";